<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 417 417"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <path
      d="M208.333,4.215c112.656,-0 204.119,91.462 204.119,204.118c-0,112.656 -91.463,204.119 -204.119,204.119c-112.656,-0 -204.118,-91.463 -204.118,-204.119c-0,-112.656 91.462,-204.118 204.118,-204.118Zm-23.052,234.584c-1.869,2.525 -4.75,4.105 -7.884,4.326c-3.134,0.22 -6.207,-0.942 -8.411,-3.181c-9.943,-10.101 -25.949,-26.359 -35.355,-35.914c-2.007,-2.039 -4.745,-3.193 -7.606,-3.207c-2.862,-0.014 -5.61,1.114 -7.637,3.134c-4.441,4.425 -10.012,9.977 -14.437,14.387c-4.188,4.173 -4.218,10.944 -0.069,15.154c16.145,16.383 54.121,54.917 71.379,72.429c2.204,2.237 5.275,3.397 8.407,3.177c3.132,-0.22 6.011,-1.799 7.881,-4.321c24.693,-33.321 103.385,-139.508 126.381,-170.539c3.522,-4.752 2.541,-11.457 -2.195,-15.002c-5.556,-4.158 -12.773,-9.559 -18.347,-13.73c-2.289,-1.714 -5.167,-2.444 -7.997,-2.029c-2.829,0.415 -5.377,1.94 -7.078,4.239c-19.264,26.022 -76.458,103.284 -97.032,131.077Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAccept"
};
</script>
